import React, { useState } from "react";

// UTLIS Import
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";

// COMMON Import
import SwitcherTabs from "../../CommonButtons/SwitcherTabs";
import IconRoundButton from "../../CommonButtons/IconRoundButton";
import SecondaryRightIconSmallButton from "../../CommonButtons/SecondaryRightIconSmallButton";
import PrimaryButton from "../../CommonButtons/PrimaryButton";
import SmallPopup from "../../CommonSmallPopup";
import SingleSelectDropDownComponent from "../../CommonDropdown/SingleSelectDropdown";
import ICONS from "../../../../assets/Icons";

/**
 * Renders the large redirect popup used across beneficiary account flows.
 *
 * @param {object} props                                React props.
 * @param {string} props.headerTitle                    Heading text displayed on the top left.
 * @param {string} props.headersubtext                  Secondary text displayed below the header.
 * @param {Function} [props.fullviewhandleFunction]     Handler invoked when the full view CTA is clicked (defaults to no-op).
 * @param {boolean} props.fullviewisDisabled            Disable state for the full view CTA.

 
 
 * @param {string} props.fullviewdisabledBgColor        Background color when the full view CTA is disabled.
 * @param {React.Ref} props.fullviewbuttonRef           Ref forwarded to the full view CTA button.
 * @param {boolean} props.isfullViewrequired             Controls whether the full view CTA is rendered.
 
 * @param {Function} props.closeiconhandleFunction      Handler invoked when the close button is clicked.
 * @param {boolean} props.closeiconisDisabled           Disable state for the close button.

 
 * @param {React.Ref} props.closeiconbuttonRef          Ref forwarded to the close button.

 * @param {string} props.bottomHeaderText               Text displayed in the secondary header bar.
 * @param {boolean} props.bottomHeaderTextNeed          Toggles rendering of the secondary header copy.
 * @param {boolean} props.isbottomSectionneed           Controls whether the bottom bar (text + CTA) is shown.
 
  * @param {boolean} props.isHeaderImgNeed           showing Img on Header.

 * @param {string} props.btnText                        Primary action button label.
 * @param {string} props.btnType                        Button type for the primary action button.
 * @param {Function} props.handleFunction               Handler invoked when the primary action button is clicked.
 * @param {boolean} props.isDisabled                    Disable state for the primary action button.
 * @param {string} props.enabledTextColor               Enabled text color for the primary action button.
 * @param {string} props.outLineColor                   Outline color for the primary action button.
 * @param {boolean} props.fullWidthRequired             Whether the primary button should stretch full width.
 * @param {string} props.disabledTextColor              Text color when the primary button is disabled.
 * @param {string} props.enabledBgColor                 Background color when the primary button is enabled.
 * @param {string} props.disabledBgColor                Background color when the primary button is disabled.
 * @param {boolean} props.isLoading                     Loading state for the primary action button.
 * @param {React.Ref} props.buttonRef                   Ref forwarded to the primary action button.
 * @param {boolean|string} props.inActiveVariantNeeded  Controls inactive variant styling for the primary button.
 * @param {boolean} props.isLoaderNeeded                Controls whether an additional loader is shown.
 * @param {boolean} props.confirmbtnrequired            Toggles rendering of the primary confirmation button.
 * @param {React.ReactNode} [props.content]              Content to be rendered in the main content area (alternative to children).
 * @param {React.ReactNode} [props.children]             Content to be rendered in the main content area (used if content prop is not provided).
 */
const LargePopupRedirect = ({
  headerTitle,
  headersubtext,
  fullviewhandleFunction = () => {},
  fullviewisDisabled,
  fullviewdisabledBgColor,
  fullviewbuttonRef,
  isfullViewrequired,
  closeiconhandleFunction,
  closeiconisDisabled,
  closeiconbuttonRef,
  bottomHeaderText,
  btnText,
  handleFunction,
  isDisabled,
  enabledTextColor,
  hoverOption,
  outLineColor,
  fullWidthRequired,
  disabledTextColor,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  buttonRef,
  inActiveVariantNeeded,
  isLoaderNeeded,
  bottomHeaderTextNeed,
  confirmbtnrequired,
  isbottomSectionneed,
  content,
  children,
  type,
  isscrollRequired,
  ispanbankRequired,
  isCreditDebitRequired,
  togglepan,
  toggleBank,
  redirectHeader,
  redirectIcon,
  smallPopupHeader,
  smallpopupsubtext,
  isActiveInactiveRequired,
  isDropDownRequired,
  dropDownValue,
  handleDropdownChange,
  toggleInactive,
  toggleActive,
  isDropDownDisabled,
  initialActiveTab,
  dropDownOptions,
  isHeaderImgNeed,
  ShowIcon,
  initialPanTab,
  handleCloseValue = () => {},
}) => {
  // useState
  const [isalertPopup, SetisalertPopup] = useState(false);
  const [animate, setAnimate] = useState(false);

  const toSentenceCase = (text = "") => {
    const keywords = ["PAN", "IFSC", "GST", "DIN", "CIN"];

    if (keywords.some((word) => text.includes(word))) {
      const parts = text.split(" ");

      return (
        parts?.[0]?.toUpperCase() +
        " " +
        parts
          ?.slice(GlobalConfiguration?.lengthCheckOne)
          .join(" ")
          .toLowerCase()
      );
    }

    return (
      text.charAt(GlobalConfiguration?.lengthCheckZero).toUpperCase() +
      text.slice(GlobalConfiguration?.lengthCheckOne).toLowerCase()
    );
  };
  const needsFullStop = (text = "") => !text.trim().endsWith(".");

  return (
    <>
      {isalertPopup && (
        <div
          className={`fixed z-z-index-max flex  items-center justify-center  top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity`}
        >
          <SmallPopup
            headerTitle={smallPopupHeader || "Open in full view?"}
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext={
              smallpopupsubtext ||
              "Leaving this page will exit you from current flow."
            }
            btnOneText="Cancel"
            btnOneHandleFunction={() => SetisalertPopup(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={() => {
              SetisalertPopup(false);
              fullviewhandleFunction();
            }}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      <div className="fixed z-z-index-modal top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
        <div
          className={` animate-none ${animate ? "Qmd:animate-slideInFromLeftSmallPopUp" : "Qmd:animate-slideInFromRightSmallPopUp"} mx-auto  fixed top-left-base h-screen w-screen flex justify-center items-center`}
        >
          <div
            style={{
              backgroundColor: "var(--primary-card)",
            }}
            className="fixed   w-standard-largePopup-width h-popup-height z-z-index-modal overflow-hidden flex justify-between rounded-border-radius-md  flex-col"
          >
            <div className="top-left-base bg-primary-bg z-z-index-dropdown flex p-padding-md left-left-base justify-between gap-gap-sm items-center w-width-full">
              <div className="flex flex-col gap-gap-xs max-w-temp-popup-header-width">
                <div className="flex gap-gap-sm items-center">
                  <div className="flex gap-gap-sm items-center">
                    {isHeaderImgNeed && (
                      <img
                        className="h-icon-md w-icon-md"
                        src={ShowIcon}
                        alt=""
                      />
                    )}

                    <p
                      className={`font-semibold text-font-md text-text-primary`}
                    >
                      {toSentenceCase(headerTitle)}
                    </p>
                  </div>
                </div>

                {headersubtext && (
                  <span className="font-normal text-font-xs text-text-secondary">
                    {linkIdentifier(headersubtext)}
                    {needsFullStop(headersubtext) && <span>.</span>}
                  </span>
                )}
              </div>

              <div className="flex gap-gap-sm items-center  justify-center flex-shrink-0">
                {isDropDownRequired && (
                  <div className="w-[var(--dropdown-width)]">
                    {" "}
                    <SingleSelectDropDownComponent
                      type="small"
                      options={dropDownOptions}
                      selected={dropDownValue}
                      placeholder={"Select"}
                      showSearch={false}
                      showCloseButton={
                        dropDownOptions[0] === dropDownValue ? false : true
                      }
                      enableCloseClick={true}
                      setCloseValue={handleCloseValue}
                      setSelected={(val) => {
                        handleDropdownChange(val);
                      }}
                      disabled={isDropDownDisabled}
                    />
                  </div>
                )}
                {ispanbankRequired && (
                  <SwitcherTabs
                    initialActiveTab={initialPanTab || "Pan"}
                    tabs={[
                      {
                        label: "PAN",
                        key: "Pan",
                        handler: togglepan,
                      },
                      {
                        label: "Bank",
                        key: "Bank",
                        handler: toggleBank,
                      },
                    ]}
                  />
                )}
                {isActiveInactiveRequired && (
                  <SwitcherTabs
                    initialActiveTab={initialActiveTab}
                    isDisabled={isDropDownDisabled}
                    tabs={[
                      {
                        label: "Active",
                        key: "active",
                        handler: toggleActive,
                        isDisabled: isDropDownDisabled,
                      },
                      {
                        label: "Inactive",
                        key: "inactive",
                        handler: toggleInactive,
                        isDisabled: isDropDownDisabled,
                      },
                    ]}
                  />
                )}
                {isCreditDebitRequired && (
                  <SwitcherTabs
                    initialActiveTab="Credit"
                    tabs={[
                      {
                        label: "Credit",
                        key: "Credit",
                        handler: togglepan,
                      },
                      {
                        label: "Debit",
                        key: "Debit",
                        handler: toggleBank,
                      },
                    ]}
                  />
                )}
                <div>
                  {isfullViewrequired && (
                    <SecondaryRightIconSmallButton
                      btnText={redirectHeader || "Open in full view"}
                      btnType={"button"}
                      handleFunction={(e) => {
                        e.stopPropagation();
                        SetisalertPopup(true);
                      }}
                      isDisabled={fullviewisDisabled}
                      enabledTextColor={"var(--text-primary)"}
                      enabledBgColor={"var(--primary-nav)"}
                      hoverOption={"white"}
                      icon={
                        redirectIcon ||
                        "https://q2pay.in/new_assets/common/others/redirect.svg"
                      }
                      imgColor={redirectIcon ? "var(--text-primary)" : ""}
                      disabledBgColor={fullviewdisabledBgColor}
                      isLoading={false}
                      buttonRef={fullviewbuttonRef}
                    />
                  )}
                </div>

                <IconRoundButton
                  enabledBgColor={"var(--primary-nav)"}
                  isLoading={false}
                  handleFunction={() => {
                    if (!closeiconisDisabled) {
                      setAnimate(true);
                      setTimeout(() => {
                        closeiconhandleFunction();
                      }, IntervalConfiguration.intervalExtraSmall);
                    }
                  }}
                  icon={
                    "https://q2pay.in/new_assets/common/create_flow/close.svg"
                  }
                  hoverOption={"white"}
                  btnType={"button"}
                  isDisabled={closeiconisDisabled}
                  buttonRef={closeiconbuttonRef}
                  title={"Close"}
                  disabledBgColor={""}
                />
              </div>
            </div>

            {/* Content Area - Container for user content */}
            {/* Priority: content prop > children */}
            <div
              className={`flex-1 ${isscrollRequired ? "overflow-y-auto overflow-x-hidden" : "overflow-y-hidden"} w-width-full ${type === "BulkUploadDetails" && "overflow-y-hidden flex flex-col flex-1"}  bg-primary-bg`}
            >
              {content || children}
            </div>

            {isbottomSectionneed && (
              <div className="top-left-base bg-primary-nav-act z-z-index-header flex gap-gap-sm p-padding-md left-left-base justify-between items-center w-width-full">
                {bottomHeaderTextNeed && (
                  <p
                    className={`max-w-popup-footer-width text-text-secondary text-font-sm font-normal`}
                  >
                    {linkIdentifier(bottomHeaderText)}
                  </p>
                )}
                {confirmbtnrequired && (
                  <div className=" flex-shrink-0">
                    <PrimaryButton
                      btnText={btnText}
                      btnType={"button"}
                      handleFunction={handleFunction}
                      isDisabled={isDisabled}
                      enabledTextColor={enabledTextColor}
                      disabledTextColor={disabledTextColor}
                      enabledBgColor={enabledBgColor}
                      disabledBgColor={disabledBgColor}
                      outLineColor={outLineColor}
                      fullWidthRequired={fullWidthRequired}
                      hoverOption={hoverOption}
                      isLoading={isLoading}
                      buttonRef={buttonRef}
                      inActiveVariantNeeded={inActiveVariantNeeded}
                      isLoaderNeeded={isLoaderNeeded}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LargePopupRedirect;
